"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LicensesConverter = void 0;
const LinkEntity_1 = require("../common/model/LinkEntity");
const dayjs_1 = __importDefault(require("../../dayjs"));
class LicensesConverter {
    static convert(response) {
        return {
            videoId: response.videoId,
            license: {
                ...response.license,
                startDate: new Date(response.license.startDate),
                endDate: new Date(response.license.endDate),
            },
            videoMetadata: {
                ...response.videoMetadata,
                duration: dayjs_1.default.duration(response.videoMetadata.duration),
                links: response.videoMetadata._links
                    ? {
                        self: new LinkEntity_1.Link(response.videoMetadata._links.self),
                        download: response.videoMetadata._links.download &&
                            new LinkEntity_1.Link(response.videoMetadata._links.download),
                        createEmbedCode: response.videoMetadata._links.createEmbedCode &&
                            new LinkEntity_1.Link(response.videoMetadata._links.createEmbedCode),
                        transcript: response.videoMetadata._links.transcript &&
                            new LinkEntity_1.Link(response.videoMetadata._links.transcript),
                        downloadMetadata: response.videoMetadata._links.downloadMetadata &&
                            new LinkEntity_1.Link(response.videoMetadata._links.downloadMetadata),
                        downloadCaptions: response.videoMetadata._links.downloadCaptions &&
                            new LinkEntity_1.Link(response.videoMetadata._links.downloadCaptions),
                    }
                    : undefined,
            },
        };
    }
}
exports.LicensesConverter = LicensesConverter;
//# sourceMappingURL=LicensesConverter.js.map